module.exports = __webpack_public_path__ + "static/media/icon-axis.8a41bf9f.svg";